module.exports = __webpack_public_path__ + "static/media/ios-information-circle.4792d284.svg";